<template>
  <div>
    <div style="margin-top: 30px">
      <div style="float:right">
        <button type="button" class="btn btn-sm btn-default" style="float:right; border: 0" @click="removePage"
                content="Detailansicht löschen" v-tippy>
          <i class="fa fa-close" style="color: black"></i>
        </button>
      </div>
      <label>Detailansicht {{ index + 1 }}</label> <a class="fa fa-question-circle" v-tippy
                                                              content="Maximal 10MB pro Upload, Seiten in PDFs werden automatisch zu Bildern konvertiert."></a>
    </div>
    <br>
    <div v-if="!record.media_src" style="background: #eeeeee; border-radius: 15px; min-height: 50px">
      <file-pond
          name="image"
          ref="pond"
          label-idle="Hier klicken oder Bild reinziehen..."
          :allow-multiple="false"
          :accepted-file-types="acceptedFiles()"
          maxFileSize="10MB"
          :server="server"
          @processfile="afterUpload"
          :disabled="disabled"
      />
    </div>
    <div v-else>
      <br>
      <div class="col-md-12" style="display: flex; align-items: center">
        <div class="col-md-1">
          <button class="btn btn-danger float-right" style="margin-top: 50%;" slot="browse-btn"
                  content="Bild entfernen"
                  @click="removeImage()"
                  :disabled="disabled"
                  v-tippy><i class="fa fa-trash"></i>
          </button>
        </div>
        <div class="col-md-11">
          <div style="display: flex; justify-content: center;  background: #eeeeee; border-radius: 15px; margin-bottom: 10px"
               @mousemove="handleMouseMove">
            <div style="position: relative; user-select: none;">
              <img :src="record.media_src" style="max-width: 100%; max-height: 350px;"
                   @mousemove="handleMouseMove" draggable="false" @mouseleave="handleMouseLeave"
                   @mousedown="handleMouseDown" @mouseup="handleMouseUp">
              <div v-if="typeof record.metadata !== 'undefined'">
                <div class="verticalLineLeft"
                     :style="'height: 100%; width: '+Math.round(record.metadata.computedWidth*0.1)+'px;'"></div>
                <div class="horizontalLineTop"
                     :style="'width: 100%; top: 0; height: '+Math.round(record.metadata.computedHeight*0.1)+'px;'"></div>
                <div class="verticalLineRight"
                     :style="'height: 100%; left: '+Math.round(record.metadata.computedWidth*0.9)+'px; width: '+Math.round(record.metadata.computedWidth*0.1)+'px;'"></div>
                <div class="horizontalLineBottom"
                     :style="'width: 100%; top: '+Math.round(record.metadata.computedHeight*0.9)+'px; height: '+Math.round(record.metadata.computedHeight*0.1)+'px;'"></div>
              </div>
              <div v-for="(mark,index) in record.marks"
                   style="position: absolute; top: 0; left: 0">
                <div class="product-mark"
                     :style="'top:' + (mark.y -10)+ 'px; left: '+ (mark.x -10) + 'px;'">
                  <a class="fa fa-external-link"></a>
                  <div
                      style="position:absolute; left:-35px; top:-25px; width: 90px; height: 22px; background: rgba(21,21,21,0.75); border-radius: 5px">
                    <p style="color: white">{{ 'Produktlink ' + (index + 1) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div v-for="(mark,index) in record.marks">
        <advertisement-mark :record="mark" :index="index" :page="record"></advertisement-mark>
      </div>
      <div class="col-md-12" style="margin-top: 10px; margin-bottom: 10px">
        <button type="button" class="btn btn-success col-md-6" @click="addNewElement">
          <i class="fa fa-plus"></i> Neuen Produktlink hinzufügen
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import vueFilePond, {setOptions} from "vue-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import de_DE from "filepond/locale/de-de"
import AdvertisementMark from "./AdvertisementMark.vue";

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);

setOptions(de_DE)

export default {
  name: 'AdvertisementPage',
  components: {AdvertisementMark, FilePond},
  props: ['disabled', 'record', 'index', 'advertisement'],
  data() {
    return {
      files: [],
      server: {
        url: '/api/content-hub/pdf/upload',
        process: {
          url: '',
          method: 'POST',
          withCredentials: true,
          headers: {},
          timeout: 60000,
          ondata: (formData) => {
            formData.append('id', this.advertisement.id);
            formData.append('client_id', this.advertisement.client_id)
            return formData;
          },
        }
      },
    }
  },
  async mounted() {
    if (!Array.isArray(this.record.marks) || this.record.marks.length === 0) this.record.marks = [];
  },
  computed: {
    ...mapGetters({
      'mediaType': 'getMediaType'
    })
  },
  methods: {
    updateMetadata(event) {

      if(this.record.metadata === undefined) this.getImageMetadata();

      let metadata = this.record.metadata;
      if (!metadata) return;
      let bounds = event.target.getBoundingClientRect();
      metadata.imgBoundsX = bounds.x;
      metadata.imgBoundsY = bounds.y;
      metadata.imgMousePosX = event.clientX - metadata.imgBoundsX;
      metadata.imgMousePosY = event.clientY - metadata.imgBoundsY;

      this.$parent.$forceUpdate();
      this.$forceUpdate();
    },
    handleMouseMove(event) {
      for (let mark of this.record.marks) {
        mark.x += 0.0000000001;
        mark.y += 0.0000000001;
        mark.relative_x += 0.0000000001;
        mark.relative_y += 0.0000000001;
      }

      this.updateMetadata(event);

      let metadata = this.record.metadata;
      if (!metadata || !metadata.selectedMark) return;

      metadata.selectedMark.x = metadata.imgMousePosX;
      metadata.selectedMark.y = metadata.imgMousePosY;

      for (let mark of this.record.marks) {
        if (mark === metadata.selectedMark) {
          mark.x = metadata.imgMousePosX;
          mark.y = metadata.imgMousePosY;
          mark.relative_x = mark.x / metadata.computedWidth;
          mark.relative_y = mark.y / metadata.computedHeight;
        }
      }
    },
    handleMouseDown(event) {
      this.updateMetadata(event);

      let metadata = this.record.metadata;
      if (!metadata) return;

      for (let mark of this.record.marks) {
        let distance = Math.pow(metadata.imgMousePosX - mark.x + 2, 2) + Math.pow(metadata.imgMousePosY - mark.y + 2, 2);
        if (distance < 121) { //Square 11, because that is the marker radius, no need for sqrt
          metadata.selectedMark = mark;
          return;
        }
      }
    },
    handleMouseUp(event) {
      this.updateMetadata(event);
      let metadata = this.record.metadata;
      if (!metadata) return;

      metadata.selectedMark = null;
    },
    handleMouseLeave(event) {
      this.updateMetadata(event);
      let metadata = this.record.metadata;
      if (!metadata) return;

      metadata.selectedMark = null;
    },
    addNewElement() {
      this.record.marks.push({
        x: 200,
        y: 200,
        relative_x: 0.5,
        relative_y: 0.5
      });

      this.$forceUpdate();
      this.$parent.$forceUpdate();
    },
    getImageMetadata() {
      if (!this.record.metadata)
        this.record.metadata = {
          imgBoundsX: 0,
          imgBoundsY: 0,
          imgMousePosX: 0,
          imgMousePosY: 0,
          imgAspect: 1.0,
          imgWidth: 0,
          imgHeight: 0,
          computedWidth: 200,
          computedHeight: 200,
          selectedMark: null,
        }

      let metadata = this.record.metadata;
      if (this.record.media_src) {
        let image = new Image();
        image.onload = function () {
          metadata.imgWidth = image.width;
          metadata.imgHeight = image.height;
          if (metadata.imgHeight > 350) {
            metadata.imgAspect = 350 / metadata.imgHeight;
          }
          metadata.computedWidth = Math.round(metadata.imgWidth * metadata.imgAspect);
          metadata.computedHeight = Math.round(metadata.imgHeight * metadata.imgAspect);
        };
        image.src = this.record.media_src;
      }
    },
    acceptedFiles() {
      return 'image/jpeg, image/png, video/mov, video/mp4, video/quicktime, application/pdf';
    },
    removePage() {
      this.advertisement.pages.splice(this.index, 1);
    },
    isVideo(url) {
      return (url.includes('.mov') || url.includes('.mp4'))
    },
    removeImage() {
      this.record.media_src = null;
    },
    afterUpload(error, file) {
      console.log(error, file)

      const response = JSON.parse(file.serverId);

      console.log(response);

      //PDF upload
      if (response.content_url === undefined && Array.isArray(response) && response.length > 0) {
        this.record.media_src = response[0];
        for(let i = 1; i < response.length; i++){
          this.advertisement.pages.push({
            media_src : response[i],
            marks : []
          })
        }
      } else {
        this.record.media_src = response.content_url;
      }


      this.getImageMetadata();

      this.$forceUpdate();
      this.$parent.$forceUpdate();
    },
    triggerFileUploader() {
      document.getElementById("file").click()
    }
  }
}
</script>

<style scoped>
</style>
<style>
.verticalLineRight {
  border-left: 2px dashed #931e1e;
  position: absolute;
  width: 1px;
  top: 0;
  background-color: rgba(217, 122, 122, 0.4);
}

.verticalLineLeft {
  border-right: 2px dashed #931e1e;
  position: absolute;
  width: 1px;
  top: 0;
  background-color: rgba(217, 122, 122, 0.4);
}

.horizontalLineTop {
  border-bottom: 2px dashed #931e1e;
  position: absolute;
  height: 1px;
  left: 0;
  background-color: rgba(217, 122, 122, 0.4);
}

.horizontalLineBottom {
  border-top: 2px dashed #931e1e;
  position: absolute;
  height: 1px;
  left: 0;
  background-color: rgba(217, 122, 122, 0.4);
}

.product-mark {
  background: whitesmoke;
  border-radius: 10px;
  border-color: black;
  border-style: solid;
  border-width: 2px;
  width: 21px;
  height: 21px;
  position: absolute;
  z-index: 10000;
  text-align: center;
  pointer-events: none
}

.filepond--action-process-item, .filepond--credits {
  display: none !important;
}
</style>
